import TopBar from "@/components/feature/TopBar";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesSection from "./components/ServicesSection";
import HowItWorks from "./components/HowItWorks";
import WhyUs from "./components/WhyUs";
import PricingSection from "./components/PricingSection";
import ZonesSection from "./components/ZonesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqSection from "./components/FaqSection";
import BlogSection from "./components/BlogSection";
import CtaFinal from "./components/CtaFinal";
import {
  schemaLocalBusiness,
  schemaWebSite,
  renderSchema,
} from "@/lib/schemas";

export default function HomePage() {
  return (
    <>
      <title>Up Diag — Diagnostic Immobilier Paris & Île-de-France | DPE, Amiante, Plomb</title>
      <meta name="description" content="Expert en diagnostic immobilier à Paris et en Île-de-France. DPE, Amiante, Plomb, Électricité, Gaz. Certifié COFRAC, RDV sous 48h, rapport le jour même. Dès 130 €." />
      <meta name="keywords" content="diagnostic immobilier Paris, DPE Paris, diagnostic amiante IDF, diagnostic plomb Paris" />
      <link rel="canonical" href="https://updiag.fr/" />
      <script type="application/ld+json" dangerouslySetInnerHTML={renderSchema(schemaLocalBusiness())} />
      <script type="application/ld+json" dangerouslySetInnerHTML={renderSchema(schemaWebSite())} />
      <TopBar />
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <HowItWorks />
        <WhyUs />
        <PricingSection />
        <ZonesSection />
        <TestimonialsSection />
        <FaqSection />
        <BlogSection />
        <CtaFinal />
      </main>
      <Footer />
    </>
  );
}
